import { OrderActionType } from 'enums/modules/order/orderActionType';
import { OrderType } from 'enums/modules/order/orderType';
import mapPaginationListFromApi from 'rtkQuery/sharespro/mapper/shared/mapPaginationListFromApi';
import { SharesproApiResponse } from 'rtkQuery/sharespro/types/sharesproApiResponse';
import mapOrderStatusFromApi from './mapOrderStatusFromApi';

export const mapOrderListItemFromApi = (
  apiItem: ApiOrderListItem
): OrderListItem => {
  return {
    id: apiItem.id,
    name: apiItem.full_name,
    amount: apiItem.amount,
    action: apiItem.action as OrderActionType,
    type: apiItem.type as OrderType,
    createdAt: new Date(apiItem.create_timestamp * 1000),
    isIPO: apiItem.is_ipo,
    currency: apiItem.currency,
    quantity: apiItem.quantity_precision,
    price: apiItem.price,
    status: mapOrderStatusFromApi(apiItem.status),
    isAllowedToSend: apiItem.is_allowed_to_send ?? false,
  };
};

const mapOrderListFromApi = (
  resp: SharesproApiResponse<ApiPaginationListResponse<ApiOrderListItem>>
): PaginationList<OrderListItem> => {
  return mapPaginationListFromApi<OrderListItem, ApiOrderListItem>(
    resp.data,
    mapOrderListItemFromApi
  );
};

export default mapOrderListFromApi;
